module.exports = __webpack_public_path__ + "media/images/common/btn-favorite-off-c73c5710b122f2672d89821b9efa2786.svg";